import React from 'react';
import { useTranslation } from 'react-i18next';

const ClientPasswordModal = ({
    isOpen,
    onClose,
    passwordForm,
    handlePasswordChange,
    handlePasswordSubmit,
    passwordError,
    email,
    isForced = false
}) => {
    const { t } = useTranslation();

    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
            onClick={!isForced ? onClose : undefined}
        >
            <div
                className="bg-bg-card border border-gold/20 rounded-lg shadow-2xl max-w-md w-full p-8"
                onClick={e => e.stopPropagation()}
            >
                <div className="mb-6 text-center">
                    <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-warning-100/10 mb-4 border border-warning-100/20">
                        <svg className="h-8 w-8 text-warning-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                    </div>
                    <h3 className="text-2xl font-bold text-text mb-2">{t('changePasswordRequired')}</h3>
                    <p className="text-sm text-text-muted">{t('changePasswordMessage')}</p>
                </div>

                <form onSubmit={handlePasswordSubmit} className="space-y-4">
                    {/* Hidden username field for accessibility/password managers */}
                    <input
                        type="text"
                        name="username"
                        value={email || ''}
                        autoComplete="username"
                        readOnly
                        className="hidden"
                    />

                    <div>
                        <label htmlFor="oldPassword" className="block text-sm font-medium text-text-muted mb-1">
                            {t('currentPassword')} <span className="text-danger-500">*</span>
                        </label>
                        <input
                            type="password"
                            id="oldPassword"
                            name="oldPassword"
                            value={passwordForm.oldPassword}
                            onChange={handlePasswordChange}
                            className="w-full bg-bg-soft border border-gold/20 text-text rounded-lg px-4 py-2 focus:ring-2 focus:ring-gold focus:border-gold"
                            required
                            autoFocus
                            autoComplete="current-password"
                        />
                    </div>

                    <div>
                        <label htmlFor="newPassword" className="block text-sm font-medium text-text-muted mb-1">
                            {t('newPassword')} <span className="text-danger-500">*</span>
                        </label>
                        <input
                            type="password"
                            id="newPassword"
                            name="newPassword"
                            value={passwordForm.newPassword}
                            onChange={handlePasswordChange}
                            className="w-full bg-bg-soft border border-gold/20 text-text rounded-lg px-4 py-2 focus:ring-2 focus:ring-gold focus:border-gold"
                            required
                            minLength={6}
                            autoComplete="new-password"
                        />
                    </div>

                    <div>
                        <label htmlFor="confirmPassword" className="block text-sm font-medium text-text-muted mb-1">
                            {t('confirmNewPassword')} <span className="text-danger-500">*</span>
                        </label>
                        <input
                            type="password"
                            id="confirmPassword"
                            name="confirmPassword"
                            value={passwordForm.confirmPassword}
                            onChange={handlePasswordChange}
                            className="w-full bg-bg-soft border border-gold/20 text-text rounded-lg px-4 py-2 focus:ring-2 focus:ring-gold focus:border-gold"
                            required
                            autoComplete="new-password"
                        />
                    </div>

                    {passwordError && (
                        <div className="bg-danger-50 border border-danger-200 text-danger-700 px-4 py-3 rounded-lg text-sm">
                            {passwordError}
                        </div>
                    )}

                    <button
                        type="submit"
                        className="w-full bg-gold-gradient text-white hover:opacity-90 py-3 px-4 rounded-lg transition-all duration-300 font-medium text-lg border-none shadow-sm"
                    >
                        {t('changePassword')}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ClientPasswordModal;
